"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreconditionsStatus = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const TestStatus_1 = require("./TestStatus");
const tds_1 = require("@guided-methods/tds");
const react_intl_1 = require("react-intl");
const PreconditionsStatus = ({ router, messageService, context, conditions, rootChannelId, conditionResults, resolvingFailure, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const operationAssetsResult = (0, hooks_1.useOperationAssets)(router, messageService, context, conditions, rootChannelId);
    return (react_1.default.createElement("div", null,
        aConditionCouldNotBeEvaluated(resolvingFailure, conditionResults) && (react_1.default.createElement("div", { className: "pb-2", "autotest-id": 'label-aConditionCouldNotBeEvaluated' },
            react_1.default.createElement(tds_1.Message, { type: "error", headline: intl.formatMessage({
                    id: 'PreconditionStatus.Title.ConditionsNotEvaluated',
                    defaultMessage: 'Failed to evaluate preconditions status',
                }), message: intl.formatMessage({
                    id: 'PreconditionStatus.PlainText.ConditionsNotEvaluated',
                    defaultMessage: 'The system encountered an issue evaluating precondition statuses. Please close the guide and try again',
                }) }))),
        allConditionsEvaluatedButNotAllPassed(resolvingFailure, conditionResults) && (react_1.default.createElement("div", { className: "pb-2", "autotest-id": 'label-allConditionsEvaluatedButNotAllPassed' },
            react_1.default.createElement(tds_1.Message, { type: "warning", headline: intl.formatMessage({
                    id: 'PreconditionStatus.Title.ConditionsNotFulfilled',
                    defaultMessage: 'One or more preconditions are not met',
                }) }))),
        (operationAssetsResult?.type === 'Pending' || operationAssetsResult === undefined) ? (react_1.default.createElement(react_1.default.Fragment, null)) : operationAssetsResult?.type === 'Error' ? (react_1.default.createElement("span", null, intl.formatMessage({
            id: 'PreconditionStatus.PlainText.MissingInformation',
            defaultMessage: 'Failed to retrieve information about preconditions.',
        }))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        !aConditionCouldNotBeEvaluated(resolvingFailure, conditionResults) &&
            conditionResults &&
            conditionResults.sort((l, r) => l.operationIdentification.operationReference < r.operationIdentification.operationReference ? -1 : 1).map((r) => (react_1.default.createElement("div", { className: "pl-5", key: r.operationIdentification.operationReference, "autotest-id": 'text-operationReference' },
                react_1.default.createElement(TestStatus_1.TestStatus, { passed: r.result.type === 'Error' ? false : r.result.passed, caption: operationAssetsResult?.type === 'Ok'
                        ? operationAssetsResult?.assets.find((a) => isSameOperation(a, r.operationIdentification))?.what?.text ?? "" : "" }),
                react_1.default.createElement("span", { "autotest-id": `result-type-${r.result.type}` })))),
        !aConditionCouldNotBeEvaluated(resolvingFailure, conditionResults) &&
            react_1.default.createElement("div", { "autotest-id": 'title-preConditionStatusInformation' },
                react_1.default.createElement(tds_1.Message, { type: "information", minimal: true, headline: intl.formatMessage({
                        id: 'PreconditionStatus.Title.PreconditionStatus.Title.KeyOnKeyOffWait30',
                        defaultMessage: 'Wait before retrying',
                    }), message: intl.formatMessage({
                        id: 'PreconditionStatus.PlainText.KeyOnKeyOffWait30',
                        defaultMessage: 'If changing start key position, please wait 30 seconds before retrying.',
                    }) }))));
    function allConditionsEvaluatedButNotAllPassed(resolvingFailure, conditionResults) {
        return (operationAssetsResult !== undefined &&
            !resolvingFailure &&
            conditionResults &&
            conditionResults.find((r) => r.result.type === 'Error') === undefined &&
            conditionResults.find((r) => r.result.type === 'Ok' && !r.result?.passed) !== undefined);
    }
    function aConditionCouldNotBeEvaluated(resolvingFailure, conditionResults) {
        return (operationAssetsResult !== undefined && (resolvingFailure ||
            (conditionResults && conditionResults.find((r) => r.result.type === 'Error') !== undefined)));
    }
    function isSameOperation(l, r) {
        return (l.operationReference === r.operationReference &&
            l.operationReferenceVersion === r.operationReferenceVersion &&
            l.contractType.toUpperCase() === r.contractType.toUpperCase());
    }
};
exports.PreconditionsStatus = PreconditionsStatus;
